'use client';

import { EmailLayout } from '@/app/components/layout';
import { Partner } from '@/configs/partner';

import { EssenceHelpLink } from '../components';

const Content = () => {
  return (
    <EmailLayout
      title="This Page is Temporarily Unavailable"
      description="This page is currently under maintenance. Please check back soon."
      help={<EssenceHelpLink standalone />}
      imageSrc="/eop/woman-long-hair.jpg"
      partner={Partner.essence}
      isInvalid={false}
      isMaintenance={true}
    />
  );
};

export default Content;
